export const NAME = 'listItem';
export const GROUP_NAME = 'g_listItem';
// 约定的 list group 名
export const LIST_GROUP = 'g_list';
//# sourceMappingURL=conf.js.map